<template>
  <div>
    <StagingBanner v-if="isNonProd" />
    <slot />
    <NotificationContainer />
  </div>
</template>

<script lang="ts" setup>
import StagingBanner from '~/components/common/StagingBanner.vue'
import NotificationContainer from '~~/components/notifications/NotificationContainer.vue'
import { useUserSessionStore } from '~~/store/user-session'

useHead({
  htmlAttrs: {
    class: 'h-full bg-fp-gray-1',
  },
  bodyAttrs: {
    class: 'h-full',
  },
  titleTemplate: (titleChunk) =>
    titleChunk ? `${titleChunk} · FP Navigator` : 'FP Navigator',
})

const isNonProd = useRuntimeConfig().public.environment !== 'prod'
const userSessionStore = useUserSessionStore()
const { getData } = userSessionStore
// This is called using useAsyncData so that this data is populated on
// the server (SSR), i.e. blocks navigation until this is resolved.
// This needs to happen here so that the auth-check.global.ts middleware can access the user session data.
await useAsyncData(
  'getUserSessionData',
  // Make sure to return a value. This will allow Nuxt to skip running the action on the client side and reuse the value from the server.
  async () => await getData().then(() => true)
)
</script>
